import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  // スクロール監視
  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5foj33gm8mddqjelnc0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });

      if (response.ok) {
        alert('メッセージを送信しました!');
        form.reset();
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* ナビゲーション */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/85448375d37a04b159a36b9450996722.jpeg" alt="ロゴ" className="w-12 h-12 object-cover rounded-full" />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>文房具チャンネル</span>
          </div>
          <div className="flex items-center gap-8">
            <a href="#home" className={`transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>ホーム</a>
            <a href="#about" className={`transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>アバウト</a>
            <a href="#videos" className={`transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>動画</a>
            <a href="#contact" className={`transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>コンタクト</a>
          </div>
        </div>
      </nav>

      {/* ヒーローセクション */}
      <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/fdd402b6e3887322863ece8d2ad77ce3.jpeg" 
            alt="文房具の世界" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">
          <h1 className="mb-6">
            <div className="text-7xl font-black mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>文房具の世界へ</div>
            <div className="text-5xl font-light" style={{ fontFamily: "'Noto Serif JP', serif" }}>ようこそ</div>
          </h1>
          <a href="https://youtu.be/cTwASfMgrww" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            最新動画を見る
          </a>
        </div>
      </section>

      {/* 特集グリッドセクション */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            人気の<span className="text-teal-500">文房具</span><br />
            <span className="text-teal-500">カテゴリー</span>
          </h2>
          <div className="grid grid-cols-2 gap-6 h-[600px]">
            <a href="https://www.youtube.com/playlist?list=PLur8jrZs-cnj7ElA8wPIZkNY867qFT85z" target="_blank" rel="noopener noreferrer" className="relative rounded-[40px] overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow group">
              <img 
                src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/67f6aeb3849ce1d7036be2f01a478a94.jpeg" 
                alt="文房具紹介" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-8 left-8 bg-black/60 backdrop-blur-sm px-6 py-3 rounded-2xl">
                <span className="text-white text-xl font-medium">文房具紹介</span>
              </div>
            </a>
            <div className="flex flex-col gap-6">
              <a href="https://www.youtube.com/playlist?list=PLur8jrZs-cnhgyorJ3qGq4w4NeWZCB4PM" target="_blank" rel="noopener noreferrer" className="relative rounded-[40px] overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow flex-1 group">
                <img 
                  src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/e99221a7fee88f6e6e0e99cf0a37fb5c.jpeg" 
                  alt="筆箱紹介" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-sm px-6 py-3 rounded-2xl">
                  <span className="text-white text-lg font-medium">筆箱紹介</span>
                </div>
              </a>
              <a href="https://www.youtube.com/playlist?list=PLydavrVTFgGKgnKmInfXJUPxbgASDm43i" target="_blank" rel="noopener noreferrer" className="relative rounded-[40px] overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow flex-1 group">
                <img 
                  src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/0cf812969a5296d3267788327dce4940.jpeg" 
                  alt="ガジェット" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-sm px-6 py-3 rounded-2xl">
                  <span className="text-white text-lg font-medium">ガジェット</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* アバウトセクション */}
      <section id="about" className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/ce6cb3625fb6c0daf0062067cb74465d.jpeg" 
              alt="チャンネルについて" 
              className="w-full h-[600px] object-cover object-top rounded-[40px] shadow-xl"
            />
          </div>
          <div>
            <div className="inline-block bg-sky-100 text-gray-800 px-5 py-2 rounded-xl text-sm font-medium mb-6">
              チャンネルについて
            </div>
            <h2 className="text-6xl font-black mb-8 leading-tight" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              文房具の魅力を<br />お届けします
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-10" style={{ lineHeight: '1.8' }}>
              毎週、新しい文房具のレビューや使い方のコツをご紹介しています。文房具好きの皆さんと一緒に、書く楽しさ、描く喜びを共有したいと思っています。
            </p>
            <a href="https://www.youtube.com/@sohutosd" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 rounded-2xl font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
              チャンネル登録
              <i className="ri-arrow-right-up-line text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* CTAセクション(コンタクト) */}
      <section id="contact" className="grid grid-cols-2 min-h-[700px]">
        <div className="relative bg-amber-50 overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/594dee4662171c4ccbc500af10846238.jpg" 
            alt="お問い合わせ" 
            className="w-full h-full object-cover"
          />
          <div className="absolute top-12 left-12">
            <p className="text-sm text-gray-700 mb-4">お問い合わせ</p>
          </div>
          <div className="absolute bottom-12 left-12 max-w-md">
            <h2 className="text-6xl font-black leading-tight text-gray-900" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              一緒に文房具の<br />
              楽しさを<br />
              共有しましょう
            </h2>
          </div>
        </div>
        <div className="bg-white flex flex-col items-center justify-center px-16 py-20">
          <h2 className="text-5xl font-black text-center mb-8 leading-tight" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            コラボレーション<br />
            お待ちしています
          </h2>
          <p className="text-gray-600 text-center mb-12 leading-relaxed max-w-md" style={{ lineHeight: '1.8' }}>
            文房具メーカー様、ショップ様とのコラボレーションや、レビュー依頼を受け付けて募集しています。お気軽にご連絡ください
          </p>
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
            <input 
              type="text" 
              name="name" 
              placeholder="お名前" 
              required
              className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:border-teal-500 focus:outline-none transition-colors"
            />
            <input 
              type="email" 
              name="email" 
              placeholder="メールアドレス" 
              required
              className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:border-teal-500 focus:outline-none transition-colors"
            />
            <textarea 
              name="message" 
              placeholder="メッセージ" 
              rows={5}
              maxLength={500}
              required
              className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:border-teal-500 focus:outline-none transition-colors resize-none"
            ></textarea>
            <button 
              type="submit"
              className="w-full bg-gray-900 text-white px-8 py-4 rounded-full font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
            >
              メールを送る
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </form>
        </div>
      </section>

      {/* フッターセクション */}
      <footer className="bg-gray-900 text-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-start justify-between mb-16">
            <div className="flex items-center gap-3">
              <img src="https://static.readdy.ai/image/1ace8647f71863f76fe7343a61fdb7f1/85448375d37a04b159a36b9450996722.jpeg" alt="ロゴ" className="w-12 h-12 object-cover rounded-full" />
              <span className="text-xl font-bold">文房具チャンネル</span>
            </div>
            <p className="text-gray-400 max-w-md text-right">文房具の世界をもっと楽しく</p>
          </div>
          
          <div className="grid grid-cols-4 gap-12 mb-16">
            <div>
              <h4 className="font-bold mb-4 text-lg">動画</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">最新動画</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">人気動画</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">プレイリスト</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">レビュー</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4 text-lg">リソース</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">おすすめ文房具</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">使い方ガイド</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">ブログ</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4 text-lg">コミュニティ</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Discord</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Twitter</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Instagram</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
              </ul>
            </div>
            <div className="text-right">
              <p className="text-sm mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>© 2024ワタナベ文房具チャンネル制作チーム<br />All rights reserved</p>
              <div className="flex gap-4 justify-end">
                <a href="https://youtube.com/@sohutosd" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-xl"></i>
                </a>
                <a href="https://x.com/sohutosd" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
                <a href="https://www.instagram.com/sohutosd/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-discord-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-12 items-center pt-12 border-t border-gray-800">
            <div className="rounded-3xl overflow-hidden h-48">
              <img 
                src="https://readdy.ai/api/search-image?query=cozy%20stationery%20workspace%20scene%20with%20notebooks%20and%20pens%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20aesthetic%20flat%20lay%20photography%2C%20inviting%20atmosphere&width=400&height=300&seq=footer1&orientation=landscape" 
                alt="文房具シーン" 
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="text-4xl font-light leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                書く喜びを<br />あなたに
              </h3>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
